export const SubscriptionTypeEnum = Object.freeze({
    ADVISER: 'ADVISER',
    PLATFORM: 'PLATFORM'
});

export default SubscriptionTypeEnum;
